// src/data/loadLangCsv.js
// Gemeinsamer Teil der Loader für Inhalte je Lernsprache (<lang>_phrases.csv,
// <lang>_topics.csv, <lang>_sentences_cloze.csv): Datei laden, in Zeilen zerlegen,
// fehlende Datei erkennen.

/**
 * Lädt /data/<lang>_<name>.csv und liefert die nicht leeren Zeilen (Kopfzeile zuerst).
 * Fehlt die Datei, kommt `null` zurück: bei 404 oder wenn der Dev-Server statt der
 * Datei index.html ausliefert (erste Zeile beginnt dann mit "<").
 */
export async function fetchLangCsvLines(lang, name) {
  const file = `${lang}_${name}.csv`;
  const res = await fetch(`/data/${file}`);
  if (res.status === 404) return null;
  if (!res.ok) {
    throw new Error(`Konnte ${file} nicht laden (Status ${res.status})`);
  }

  const text = await res.text();
  const lines = text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  if (lines.length === 0 || lines[0].startsWith("<")) return null;
  return lines;
}

/** Spaltennummern der Kopfzeile (Semikolon-getrennt) nach Namen. */
export function headerIndex(headerLine) {
  const map = {};
  headerLine.split(";").forEach((h, idx) => {
    map[h.trim()] = idx;
  });
  return map;
}

/** Ergebnis je Sprache merken, auch laufende Ladevorgänge (kein doppeltes Laden). */
export function cachedByLang(loader) {
  const cache = new Map();
  return (lang) => {
    if (!cache.has(lang)) {
      const promise = loader(lang).catch((e) => {
        cache.delete(lang);
        throw e;
      });
      cache.set(lang, promise);
    }
    return cache.get(lang);
  };
}
